var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Field Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction 1",
    d: "M19.8126 23.1172H9.18848C8.34322 23.1166 7.53275 22.8039 6.93495 22.2478C6.33716 21.6917 6.00088 20.9376 5.99994 20.151C6.00182 18.8403 6.56215 17.5838 7.55806 16.657C8.55397 15.7302 9.90416 15.2087 11.3126 15.207L14.4999 20.151L17.6873 15.207C19.0958 15.2084 20.4462 15.7298 21.4422 16.6567C22.4381 17.5835 22.9984 18.8402 22.9999 20.151C22.999 20.9374 22.6629 21.6913 22.0653 22.2474C21.4678 22.8035 20.6576 23.1163 19.8126 23.1172Z",
    fill: "#6D57DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2513",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6482 4C13.5792 4 12.5341 4.29502 11.6452 4.84775C10.7563 5.40048 10.0635 6.18609 9.65438 7.10525C9.24526 8.02441 9.13822 9.03582 9.34678 10.0116C9.55535 10.9874 10.0702 11.8837 10.8261 12.5872C11.582 13.2907 12.5452 13.7697 13.5937 13.9638C14.6422 14.1579 15.7291 14.0583 16.7168 13.6776C17.7044 13.2969 18.5486 12.6521 19.1426 11.8249C19.7365 10.9977 20.0535 10.0251 20.0535 9.03024C20.0535 7.69614 19.4841 6.41668 18.4704 5.47332C17.4567 4.52997 16.0818 4 14.6482 4Z",
    fill: "#6D57DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name-icon.1e9a588ed1a12f5faf9fe0aad93f13f1.svg";
export { ForwardRef as ReactComponent };